import { render } from "./Iframe.vue?vue&type=template&id=366820c5&ts=true"
import script from "./Iframe.ts?vue&type=script&lang=ts&external"
export * from "./Iframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__